"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cleanName = (firstName, lastName) => {
    if (firstName && lastName) {
        return ''.concat(firstName || '', ' ', lastName).trim();
    }
    if (lastName) {
        return lastName.trim();
    }
    if (firstName) {
        return firstName.trim();
    }
    return '';
};
exports.default = cleanName;
